<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ adminObject.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <AdministratorsTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CForm>
                        <!-- <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="6"
                                class="col-form-label">
                                Администратор бизнеса
                            </CCol>
                            <CCol sm="6">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="adminSettingsObject.is_business_admin"
                                />
                            </CCol>
                        </CRow> -->

                        <CRow class="form-group">
                            <CCol
                                tag="label"
                                sm="6"
                                class="col-form-label">
                                Роль
                            </CCol>
                            <CCol sm="4">
                                <CSelect
                                    horizontal
                                    :options="roleOptions"
                                    :value.sync="selectedRole"
                                    placeholder="Роль администратора..."
                                />
                            </CCol>
                        </CRow>
                        <CTabs
                            v-if="adminSettingsObject.is_business_admin"
                            variant="pills"
                            :active-tab="0"
                        >
                            <CTab title="Рестораны" class="pt-1">
                                <CRow
                                    v-for="restaurant in restaurants"
                                    :key="restaurant.title"
                                    class="ml-0"
                                >
                                    <CCol
                                        tag="label"
                                        sm="6"
                                        class="col-form-label">
                                        {{ restaurant.title }}
                                    </CCol>
                                    <CCol sm="6">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="restaurantsEnabled[restaurant.id]"
                                        />
                                    </CCol>
                                </CRow>
                            </CTab>

                            <CTab title="Продукты" class="pt-1">
                                <CRow
                                    v-for="grocer in grocers"
                                    :key="grocer.title"
                                    class="ml-0"
                                >
                                    <CCol
                                        tag="label"
                                        sm="6"
                                        class="col-form-label">
                                        {{ grocer.title }}
                                    </CCol>
                                    <CCol sm="6">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="grocersEnabled[grocer.id]"
                                        />
                                    </CCol>
                                </CRow>
                            </CTab>

                            <CTab title="Аптеки" class="pt-1">
                                <CRow
                                    v-for="pharmacy in pharmacies"
                                    :key="pharmacy.title"
                                    class="ml-0"
                                >
                                    <CCol
                                        tag="label"
                                        sm="6"
                                        class="col-form-label">
                                        {{ pharmacy.title }}
                                    </CCol>
                                    <CCol sm="6">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="pharmaciesEnabled[pharmacy.id]"
                                        />
                                    </CCol>
                                </CRow>
                            </CTab>

                            <CTab title="Помощники" class="pt-1">
                                <CRow
                                    v-for="assistant in assistantList"
                                    :key="assistant.id"
                                    class="ml-0"
                                >
                                    <CCol
                                        tag="label"
                                        sm="6"
                                        class="col-form-label">
                                        {{ assistant.title }}
                                    </CCol>
                                    <CCol sm="6">
                                        <CSwitch
                                            color="dark"
                                            shape="pill"
                                            variant="opposite"
                                            :checked.sync="assistantEnabled[assistant.id]"
                                        />
                                    </CCol>
                                </CRow>
                            </CTab>

                            <CTab
                                v-for="entityType in entityTypes"
                                :key="entityType.id"
                                :title="entityType.title"
                                class="pt-1">
                                <div v-if="entityType.entities && entityType.entities.length">
                                    <CRow
                                        v-for="entity in entityType.entities"
                                        :key="entity.id"
                                        class="ml-0"
                                    >
                                        <CCol
                                            tag="label"
                                            sm="6"
                                            class="col-form-label">
                                            {{ entity.title }}
                                        </CCol>
                                        <CCol sm="6">
                                            <CSwitch
                                                color="dark"
                                                shape="pill"
                                                variant="opposite"
                                                :checked.sync="entityEnabled[entity.id]"
                                            />
                                        </CCol>
                                    </CRow>
                                </div>
                            </CTab>

                        </CTabs>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="saveSettings"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import AdministratorsTabLinks from '@/components/AdministratorsTabLinks';
    import { isAuthorized } from '@/utils/role'

    export default {

        name: 'AdministratorSettings',
        components: {
            AdministratorsTabLinks,
        },

        data() {
            return {
                administratorsOpened: null,
                adminObject: {},
                adminSettingsObject: {
                    role: '',
                    is_business_admin: false,
                    entities: [],
                    restaurants: [],
                    grocers: [],
                    pharmacies: [],
                    assistant: [],
                },
                entityTypes: [],
                entityEnabled: {},
                restaurants: [],
                restaurantsEnabled: [],
                grocers: [],
                grocersEnabled: [],
                pharmacies: [],
                pharmaciesEnabled: [],
                assistantList: [],
                assistantEnabled: [],
                selectedRole: 'other',
                isAuthorized: false,
            };
        },

        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.administratorsOpened = from.fullPath.includes('administrators');
            });
        },
        computed: {
            roleOptions: function() {
                return [
                    {
                        value: 'operator',
                        label: 'Оператор/диспетчер'
                    },
                    {
                        value: 'concierge_nigth',
                        label: 'Консьерж-ночник'
                    },
                    {
                        value: 'concierge',
                        label: 'Консьерж'
                    },
                    {
                        value: 'admin',
                        label: 'Менеджер'
                    },
                    {
                        value: 'super_admin',
                        label: 'Супер админ'
                    },
                    {
                        value: 'operator_vip_city',
                        label: 'оператор VIP CITY'
                    },
                    {
                        value: 'other',
                        label: 'Другое'
                    },
                    {
                        value: 'business_admin',
                        label: 'Администратор бизнеса'
                    }
                ]
            }
        },

        mounted() {
            this.isAuthorized = isAuthorized(['super_admin']);
            const id = this.$route.params.id;
            // Administrator
            Vue.axios
                .get('/administrators/' + id)
                .then(resp => {
                    this.adminObject = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            // Administrator Settings
            Vue.axios
                .get('/administrators/' + id + '/settings')
                .then(resp => {
                    const adminSettingsObject = resp.data;
                    if (!adminSettingsObject.restaurants)
                        adminSettingsObject.restaurants = [];
                    if (!adminSettingsObject.grocers) adminSettingsObject.grocers = [];
                    if (!adminSettingsObject.pharmacies) adminSettingsObject.pharmacies = [];
                    if (!adminSettingsObject.assistant) adminSettingsObject.assistant = [];
                    this.adminSettingsObject = adminSettingsObject;
                    this.selectedRole = adminSettingsObject.role;
                    // Restaurants
                    Vue.axios
                        .get('/restaurants')
                        .then(resp => {
                            this.restaurants = resp.data;
                            this.initRestaurantsEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                    // Grocers
                    Vue.axios
                        .get('/grocers')
                        .then(resp => {
                            this.grocers = resp.data;
                            this.initGrocersEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                    // Pharmacies
                    Vue.axios
                        .get('/pharmacies')
                        .then(resp => {
                            this.pharmacies = resp.data;
                            this.initPharmaciesEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                    // Assistant
                    Vue.axios
                        .get('/assistants')
                        .then(resp => {
                            this.assistantList = resp.data;
                            this.initAssistantEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get('/entities-type/')
                .then(resp => {
                    Promise
                        .all(
                            resp.data.map(entityType => Vue.axios.get(`/entities/${entityType.code}`)
                                .then(entity => {
                                    entityType.entities = entity.data;
                                    return entityType;
                                })
                                .catch(err => {
                                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                                })
                            )
                        ).then(data => {
                            this.entityTypes = data || [];
                            this.initEntityEnabled();
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            goBack() {
                this.administratorsOpened
                    ? this.$router.go(-1)
                    : this.$router.push({ path: '/administrators' });
            },
            saveSettings() {
                // Entities
                this.adminSettingsObject.entities = [];
                Object.entries(this.entityEnabled).forEach(([key, value]) => {
                    if (value) {
                        this.adminSettingsObject.entities.push(+key);
                    }
                });
                // Restaurants
                this.adminSettingsObject.restaurants = [];
                for (let i = 0; i < this.restaurants.length; i++) {
                    if (this.restaurantsEnabled[this.restaurants[i].id]) {
                        this.adminSettingsObject.restaurants.push(this.restaurants[i].id);
                    }
                }
                // Grocers
                this.adminSettingsObject.grocers = [];
                for (let i = 0; i < this.grocers.length; i++) {
                    if (this.grocersEnabled[this.grocers[i].id]) {
                        this.adminSettingsObject.grocers.push(this.grocers[i].id);
                    }
                }
                // Pharmacies
                this.adminSettingsObject.pharmacies = [];
                for (let i = 0; i < this.pharmacies.length; i++) {
                    if (this.pharmaciesEnabled[this.pharmacies[i].id]) {
                        this.adminSettingsObject.pharmacies.push(this.pharmacies[i].id);
                    }
                }
                // Assistant
                this.adminSettingsObject.assistant = [];
                for (let i = 0; i < this.assistantList.length; i++) {
                    if (this.assistantEnabled[this.assistantList[i].id]) {
                        this.adminSettingsObject.assistant.push(this.assistantList[i].id);
                    }
                }

                if(this.selectedRole) {
                    this.adminSettingsObject.role = this.selectedRole;
                }

                console.log(this.adminSettingsObject, 'adminSettingsObject');

                Vue.axios
                    .put(
                        '/administrators/' + this.adminObject.id + '/settings',
                        this.adminSettingsObject
                    )
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения настроек.');
                    });
            },
            initRestaurantsEnabled() {
                this.restaurantsEnabled = [];
                for (let i = 0; i < this.restaurants.length; i++) {
                    this.restaurantsEnabled[
                        this.restaurants[i].id
                    ] = this.adminSettingsObject.restaurants.includes(
                        this.restaurants[i].id
                    );
                }
            },
            initGrocersEnabled() {
                this.grocersEnabled = [];
                for (let i = 0; i < this.grocers.length; i++) {
                    this.grocersEnabled[
                        this.grocers[i].id
                    ] = this.adminSettingsObject.grocers.includes(this.grocers[i].id);
                }
            },
            initPharmaciesEnabled() {
                this.pharmaciesEnabled = [];
                for (let i = 0; i < this.pharmacies.length; i++) {
                    this.pharmaciesEnabled[
                        this.pharmacies[i].id
                    ] = this.adminSettingsObject.pharmacies.includes(this.pharmacies[i].id);
                }
            },
            initAssistantEnabled() {
                this.assistantEnabled = [];
                for (let i = 0; i < this.assistantList.length; i++) {
                    this.assistantEnabled[
                        this.assistantList[i].id
                    ] = this.adminSettingsObject.assistant.includes(this.assistantList[i].id);
                }
            },
            initEntityEnabled() {
                this.entityEnabled = {};
                this.entityTypes.forEach(entityType => {
                    entityType.entities.forEach(entity => {
                        this.entityEnabled[entity.id] = this.adminSettingsObject.entities.includes(entity.id);
                    });
                });
            },
        },
    };
</script>
